import React, { useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { Share } from '@capacitor/share';
import { PLAY_STORE_URL } from './GooglePlayBadge';

const APP_URL = 'https://standlogic.app';
const SHARE_DATA = {
  title: 'StandLogic',
  text: 'Check out StandLogic - whitetail hunting outlooks based on weather and moon conditions. Free to download for Android.',
  url: APP_URL,
};

function AppPromotionCard() {
  const [sharing, setSharing] = useState(false);
  const [notice, setNotice] = useState('');
  const [error, setError] = useState('');
  const isNative = Capacitor.isNativePlatform();
  const canShare = isNative || (
    typeof navigator.share === 'function' &&
    (typeof navigator.canShare !== 'function' || navigator.canShare(SHARE_DATA))
  );

  const handleShare = async () => {
    setSharing(true);
    setNotice('');
    setError('');
    try {
      if (isNative) {
        await Share.share({ ...SHARE_DATA, dialogTitle: 'Share StandLogic' });
      } else if (canShare) {
        await navigator.share(SHARE_DATA);
      } else {
        if (!navigator.clipboard?.writeText) {
          throw new Error('Clipboard access is not available.');
        }
        await navigator.clipboard.writeText(APP_URL);
        setNotice('Link copied. Paste it into a message to a friend.');
      }
    } catch (err) {
      // Capacitor Android reports dismissal as "Share canceled"; browsers use AbortError.
      const canceled = err instanceof Error && (
        isNative ? err.message === 'Share canceled' : canShare && err.name === 'AbortError'
      );
      if (!canceled) {
        console.error('Unable to share StandLogic:', err);
        setError(canShare
          ? 'Unable to open sharing. Please try again, or copy the link below.'
          : 'Unable to copy the link. You can copy the link below to share it.');
      }
    } finally {
      setSharing(false);
    }
  };

  return (
    <section className="profile-card" aria-labelledby="app-promotion-heading">
      <h3 id="app-promotion-heading">Spread the word</h3>
      <p className="form-hint">
        Enjoying StandLogic? Share it with a friend or leave an honest rating on Google Play.
      </p>
      {notice && <div className="alert alert-success" role="status">{notice}</div>}
      {error && (
        <div className="alert alert-error" role="alert">
          {error} <a href={APP_URL} target="_blank" rel="noopener noreferrer">{APP_URL}</a>
        </div>
      )}
      <div className="app-promotion-actions">
        <button type="button" className="btn btn-primary btn-full" onClick={handleShare} disabled={sharing}>
          {sharing ? 'Please wait...' : canShare ? 'Share StandLogic' : 'Copy link'}
        </button>
        <a className="btn btn-secondary-dark btn-full" href={PLAY_STORE_URL}
          target="_blank" rel="noopener noreferrer">
          Rate on Google Play
        </a>
      </div>
    </section>
  );
}

export default AppPromotionCard;
